var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex items-center gap-3 pt-4 justify-start"},[_c('vs-button',{staticClass:"bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6",on:{"click":_vm.handleTestPayment}},[_vm._v("\n    "+_vm._s(this.buttonName || "Test")+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }